import { Controller } from '@hotwired/stimulus'
import { createCookieWithoutConsent } from '../utils/cookies'
import { disableScroll, enableScroll } from '../utils/global'

// Имя cookie знает и GiveawaysHelper::POPUP_DISMISSED_COOKIE: сервер по ней не рендерит попап.
const DISMISSED_COOKIE = 'giveaway_popup_dismissed'
const DISMISSED_DAYS = 3
const DELAY_MS = 10_000
const SESSION_STARTED_KEY = 'giveaway_popup_session_started_at'
const SHOWN_KEY = 'giveaway_popup_shown'

// Попап розыгрыша (giveaways/_popup): через 10 секунд от начала сессии, один раз за сессию. Отказ (кнопка,
// крестик, Esc, клик мимо) запоминается cookie на 3 дня; переход на страницу розыгрыша отказом не считается.
export default class GiveawayPopupController extends Controller {
  static values = { id: Number, preview: Boolean }

  connect() {
    if (this.previewValue) {
      this.open()
      return
    }
    if (sessionRead(SHOWN_KEY)) return

    let startedAt = Number(sessionRead(SESSION_STARTED_KEY))
    if (!startedAt) {
      startedAt = Date.now()
      sessionWrite(SESSION_STARTED_KEY, String(startedAt))
    }
    const wait = Math.max(0, DELAY_MS - (Date.now() - startedAt))
    this.timer = setTimeout(() => this.open(), wait)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.unlockScroll()
  }

  // Картинка в закрытом dialog не грузится (loading="lazy"): грузим её перед показом, иначе окно открылось бы пустым.
  open() {
    const image = this.element.querySelector('img')
    if (!image) return

    image.loading = 'eager'
    if (image.complete && image.naturalWidth) {
      this.show()
    } else {
      image.addEventListener('load', () => this.show(), { once: true })
    }
  }

  show() {
    if (this.element.open || !this.element.isConnected) return

    if (!this.previewValue) sessionWrite(SHOWN_KEY, '1')
    this.element.showModal()
    disableScroll()
    this.scrollLocked = true
  }

  // Ссылка уводит на страницу розыгрыша; на ней самой (превью) — просто закрываем окно.
  accept() {
    this.close()
  }

  dismiss(event) {
    event?.preventDefault()
    if (!this.previewValue) {
      createCookieWithoutConsent(
        DISMISSED_COOKIE,
        String(this.idValue),
        DISMISSED_DAYS
      )
    }
    this.close()
  }

  dismissOnBackdrop(event) {
    // У native dialog клик по backdrop приходит на сам dialog.
    if (event.target === this.element) this.dismiss(event)
  }

  close() {
    if (this.element.open) this.element.close()
    this.unlockScroll()
  }

  unlockScroll() {
    if (!this.scrollLocked) return

    enableScroll()
    this.scrollLocked = false
  }
}

// sessionStorage бывает недоступен (приватный режим, запрет cookie); без него попап просто не ограничен сессией.
function sessionRead(key) {
  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

function sessionWrite(key, value) {
  try {
    window.sessionStorage.setItem(key, value)
  } catch {
    // см. sessionRead
  }
}
